export const estiloGreen={
    background:'darkSeaGreen',
    color:'black',
}
export const estiloDark={
    background:'black',
    color:'white',
}